import React from 'react'
import { ReactComponent as VanderlandeSvg} from '../../assets/svgs/clients/Vanderlande.svg';

const VanderlandeLogo = () => (
    <div>
        <VanderlandeSvg/>
    </div>
)

export default VanderlandeLogo